// John Eldhose 20190412
import React, { Component } from 'react';
import  { Link } from 'react-router-dom';
import { Button, Grid, MenuItem, Paper, Snackbar, TextField, Typography } from '@material-ui/core';
import { Create } from '@material-ui/icons';
import { getProfile } from '../../Api/getProfile';
import { getAddress } from '../../Api/getAddress';
import { addRMA } from '../../Api/addRMA';

class RMAForm extends Component {

  state = {
    ContactName: '',
    ContactEMail: '',
    CompanyName: '',
    ShippingAddressID: '',
    ShippingAddress: '',
    ShippingCity: '',
    ShippingState: '',
    ShippingZip: '',
    ShippingCountry: '',
    BillingAddressID: '',
    BillingAddress: '',
    BillingCity: '',
    BillingState: '',
    BillingZip: '',
    BillingCountry: '',
    Product: '',
    SerialNumber: '',
    RMATitle: '',
    RMADescription: '',
    Addresses: [],
    Warning: false,
    warningMessage: '',
    Message: ''
  }
  componentWillMount() {
    this.setState(this.props.LMDCache);
    getProfile()
      .then((prof) => {
        if(prof['status'] === 'true')
          this.setState({
            ContactName: prof.data['FirstName'] + ' ' + prof.data['LastName'],
            ContactEMail: prof.data['email'],
            CompanyName: prof.data['CompanyDescription']
          });
      })
      .catch((error) => {
        console.log(error);
      })
    getAddress()
      .then((add) => {
        if(add['status'] === 'true')
          this.setState({ Addresses: add['data'] });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleUserInput = (event) => {
    this.setState ({ [event.target.name]: event.target.value });
  }
  handleAddressChange = (event) => {
    var type = (event.target.name === 'Billing') ? 'Billing' : 'Shipping';
    for(var i = 0; i < this.state.Addresses.length; i++)
      if(event.target.value === this.state.Addresses[i].ADDRESSID)
        break;
    if(i < this.state.Addresses.length) {
      this.setState({
        [type + 'AddressID']: this.state.Addresses[i].ADDRESSID,
        [type + 'Address']: this.state.Addresses[i].ADDRESS1,
        [type + 'City']: this.state.Addresses[i].CITY,
        [type + 'State']: this.state.Addresses[i].STATE,
        [type + 'Zip']: this.state.Addresses[i].POSTALCODE,
        [type + 'Country']: this.state.Addresses[i].COUNTRY
      });
    }
  }
  handleProductChange = (event) => {
    var i;
    for(i = 0; i < this.state.Products.length; i++)
      if(event.target.value === this.state.Products[i].Serial)
        break;
    if(i < this.state.Products.length) {
      this.setState({
        Product: this.state.Products[i].Product,
        SerialNumber: this.state.Products[i].Serial
      });
      this.handleUserInput({ target: {
        name: 'Product', value: this.state.Products[i].Product
      }});
    }
  }
  handleSave = () => {
    var warn = false;
    const values = Object.values(this.state);
    for(var i = 0; i < 19; i ++)
      if(values[i] === '') {
        warn = true;
        break;
      }
    if(warn)
      this.setState({
        Warning: true, warningMessage: 'Please fill-in all required fields'
      });
    else {
      this.setState({ disableSave: true });
      const keys = Object.keys(this.state);
      var data = {};
      for(i = 0; i < 19; i++)
        data[keys[i]] = values[i];
      addRMA(data)
        .then((rma) => {
          if(rma['status'] === 'true') {
            this.setState({ Message: 'Thank you for submitting RMA. It may take a while before this RMA will appear on the list of RMAs. Please check back after some time (It was send successfully, please do not resend)' });
          }
          else
            this.setState({ warningMessage: 'Submission failed. Please try back after some time' });
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>Carlson RMA</font></center>
        </Typography>
        <p />
          <Paper style={{ padding: '10px' }}>
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Contact Name'
                name='ContactName'
                value={this.state.ContactName}
                error={this.state.Warning && this.state.ContactName === ''}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Contact E-Mail'
                name='ContactEMail'
                value={this.state.ContactEMail}
                error={this.state.Warning && this.state.ContactEMail === ''}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Company Name'
                name='CompanyName'
                value={this.state.CompanyName}
                error={this.state.Warning && this.state.CompanyName === ''}
              />
            </Grid>
          </Grid>
          <Typography variant='caption'>
            <Link to='/profile?rmaform'>Update Profile</Link>
          </Typography>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                fullWidth
                select
                label='Select an existing address from the list'
                name='Shipping'
                value={this.state.ShippingAddressID}
                onChange={(event) => this.handleAddressChange(event)}
              >
                {this.state.Addresses.map((option) => (
                  <MenuItem key={option.ADDRESSID} value={option.ADDRESSID}>
                    {option.ADDRESS1}, {option.CITY}, {option.STATE}, {option.POSTALCODE}, {option.COUNTRY}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                disabled
                required
                fullWidth
                label='Shipping Address'
                name='ShippingAddress'
                value={this.state.ShippingAddress}
                error={this.state.Warning && this.state.ShippingAddress === ''}
              />
              <TextField
                disabled
                required
                fullWidth
                label='City'
                name='ShippingCity'
                value={this.state.ShippingCity}
                error={this.state.Warning && this.state.ShippingCity === ''}
              />
              <Grid container>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='State'
                    name='ShippingState'
                    value={this.state.ShippingState}
                    error={this.state.Warning && this.state.ShippingState === ''}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: '5px' }}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='Zip'
                    name='ShippingZip'
                    value={this.state.ShippingZip}
                    error={this.state.Warning && this.state.ShippingZip === ''}
                  />
                </Grid>
              </Grid>
              <TextField
                disabled
                required
                fullWidth
                label='Country'
                name='ShippingCountry'
                value={this.state.ShippingCountry}
                error={this.state.Warning && this.state.ShippingCountry === ''}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                fullWidth
                select
                label='Select a billing address from the list'
                name='Billing'
                value={this.state.BillingAddressID}
                onChange={(event) => this.handleAddressChange(event)}
              >
                {this.state.Addresses.map((option) => (
                  <MenuItem key={option.ADDRESSID} value={option.ADDRESSID}>
                    {option.ADDRESS1}, {option.CITY}, {option.STATE}, {option.POSTALCODE}, {option.COUNTRY}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                disabled
                required
                fullWidth
                label='Billing Address'
                name='BillingAddress'
                value={this.state.BillingAddress}
                error={this.state.Warning && this.state.BillingAddress === ''}
              />
              <TextField
                disabled
                required
                fullWidth
                label='City'
                name='BillingCity'
                value={this.state.BillingCity}
                error={this.state.Warning && this.state.BillingCity === ''}
              />
              <Grid container>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='State'
                    name='BillingState'
                    value={this.state.BillingState}
                    error={this.state.Warning && this.state.BillingState === ''}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: '5px' }}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='Zip'
                    name='BillingZip'
                    value={this.state.BillingZip}
                    error={this.state.Warning && this.state.BillingZip === ''}
                  />
                </Grid>
              </Grid>
              <TextField
                disabled
                required
                fullWidth
                label='Country'
                name='BillingCountry'
                value={this.state.BillingCountry}
                error={this.state.Warning && this.state.BillingCountry === ''}
              />
            </Grid>
          </Grid>
          <Typography variant='caption'>
            <Link to='/accountdetailsteam?rmaform'>Update Address</Link>
          </Typography>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='Product'
                name='Product'
                value={this.state.Product}
                error={this.state.Warning && this.state.Product === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='Serial Number'
                name='SerialNumber'
                value={this.state.SerialNumber}
                error={this.state.Warning && this.state.SerialNumber === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='RMA Title'
                name='RMATitle'
                value={this.state.RMATitle}
                error={this.state.Warning && this.state.RMATitle === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='RMA Description'
                multiline={true}
                rows={4}
                name='RMADescription'
                value={this.state.RMADescription}
                error={this.state.Warning && this.state.RMADescription === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                variant='raised'
                color='primary'
                fullWidth
                style={{ textTransform: 'none' }}
                onClick={this.handleSave}
                disabled={this.state.disableSave}
              >
                <Create /> &nbsp; Create new RMA
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.Message !== '' || this.state.warningMessage !== ''}
          onClose={() => this.setState({ Message: '', warningMessage: '' })}
          message={
            <span>
              <div style={{ textAlign: 'left', whiteSpace: 'pre-line' }}>
                {this.state.Message}
              </div>
              <span style={{ color: 'red' }}>
                {this.state.warningMessage}
              </span>
            </span>
          }
        />
      </div>
    );
  }
}

export default RMAForm;



// WEBPACK FOOTER //
// ./src/components/home/RMAForm.js